module.exports = __webpack_public_path__ + "static/q13-51b394908de0992361844314eab13293.png";